import { Box, Text, VStack } from '@chakra-ui/react';
import React from 'react';

export function KeyValuePair({
    label,
    children,
    showNotSpecifiedOnNull = false,
    ...props
}: { label: string;
    children: React.ReactNode;
    showNotSpecifiedOnNull?: boolean;
} & React.ComponentProps<typeof VStack>) {
    return (
        <VStack align="flex-start" spacing={1} {...props}>
            <Text
                fontSize={showNotSpecifiedOnNull ? 'inherit' : 'xs'}
                fontWeight={showNotSpecifiedOnNull ? 'medium' : 'inherit'}
            >
                {label}
            </Text>
            <Box>
                {showNotSpecifiedOnNull && children === null
                    ? <Text color="muted.300">Not specified</Text> : children}
            </Box>
        </VStack>
    );
}
